export enum MessageSmsService {
  Sms = "SMS",
  Mms = "MMS",
  Rcs = "RCS",
  Imessage = "iMessage",
}
